import Vue from 'vue';
import {
    global
} from './global.js';



export default {
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
    // 'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/json',

    getCheck1(url, params) {
        return new Promise((resolve, reject) => {
            fetch(global[0].BASE_URL + url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: params,
            }).then((response) => {
                console.log(response)
                return response;
            }).then((result) => {
                resolve(result);
            }).catch((err) => {
                reject(err);
            });
        });
    },

    getCheck2(url, params ) {
        params['Access-Control-Allow-Origin'] = '*';
        params['Access-Control-Allow-Methods'] = 'POST, GET, PUT, OPTIONS, DELETE';
        params['Access-Control-Allow-Headers'] = 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type';
        params['Content-Type'] = 'application/json';
        params['Accept'] = 'application/json';
        Vue.axios.get(global[0].BASE_URL + url, {
            headers: params
        }).then((res) => {
            console.log(res);
        }).catch((err) => {
            console.log(err);
        })
    },

    get(url, params) {
        // params['Access-Control-Allow-Origin']='*'
        // params = this.updateHeader(params);
        return new Promise((resolve, reject) => {
            Vue.axios.get(global[0].BASE_URL + url, {
                headers: params
            }).then((response) => {
                // console.log(response);
                resolve(response)
            })
                .catch((err) => {
                    if (err.response && err.response.status && err.response.status == 401) {
                        // console.log(err.response.status);
                        // window.location.reload()
                        window.location.href = '/#/login';
                    }
                    if (err.response && err.response.status && err.response.status == 403) {
                        console.log("You don't have Access!");
                        // window.location.reload()
                        // Vue.prototype.$notify({
                        //     title: 'Important message',
                        //     message: "You don't have Access!",
                        //     type: 'error'
                        // });
                    }
                    reject(err)
                })
        });
    },

    getUrl(url, params) {
        return new Promise((resolve, reject) => {
            Vue.axios.get(url, {
                    headers: params
                }).then((response) => resolve(response))
                .catch((err) => {
                    if (err.response && err.response.status && err.response.status == 401) {
                        // console.log(err.response.status);
                        // window.location.reload()
                        window.location.href = '/#/login';
                    }
                    if (err.response && err.response.status && err.response.status == 403) {
                        console.log("You don't have Access!");
                        // window.location.reload()
                        // Vue.prototype.$notify({
                        //     title: 'Important message',
                        //     message: "You don't have Access!",
                        //     type: 'error'
                        // });
                    }
                    reject(err)
                })
        });
    },
    post(url, params, request_header) {
        return new Promise((resolve, reject) => {
            Vue.axios.post(global[0].BASE_URL + url, params, {
                    headers: request_header
                }).then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    if (err.response && err.response.status && err.response.status == 401) {
                        // console.log(err.response.status);
                        // window.location.reload()
                        window.location.href = '/#/login';
                    }
                    if (err.response && err.response.status && err.response.status == 403) {
                        console.log("You don't have Access!");
                        // window.location.reload()
                        // Vue.prototype.$notify({
                        //     title: 'Important message',
                        //     message: "You don't have Access!",
                        //     type: 'error'
                        // });
                    }
                    reject(err);
                });
        });
    },
    put(url, params, request_header) {
        return new Promise((resolve, reject) => {
            Vue.axios.put(global[0].BASE_URL + url, params, {
                    headers: request_header
                }).then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    if (err.response && err.response.status && err.response.status == 401) {
                        // console.log(err.response.status);
                        // window.location.reload()
                        window.location.href = '/#/login';
                    }
                    if (err.response && err.response.status && err.response.status == 403) {
                        console.log("You don't have Access!");
                        // window.location.reload()
                        // Vue.prototype.$notify({
                        //     title: 'Important message',
                        //     message: "You don't have Access!",
                        //     type: 'error'
                        // });
                    }
                    reject(err);
                });
        });
    },
    del(url, request_header) {
        // Vue.axios.delete(global[0].BASE_URL+url,params).then((response) => Promise.resolve(response))
        //    .catch((err) => Promise.reject(err))
        return new Promise((resolve, reject) => {
            Vue.axios.delete(global[0].BASE_URL + url, {
                    headers: request_header
                }).then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    if (err.response && err.response.status && err.response.status == 401) {
                        // console.log(err.response.status);
                        // window.location.reload()
                        window.location.href = '/#/login';
                    }
                    if (err.response && err.response.status && err.response.status == 403) {
                        console.log("You don't have Access!");
                        // window.location.reload()
                        // Vue.prototype.$notify({
                        //     title: 'Important message',
                        //     message: "You don't have Access!",
                        //     type: 'error'
                        // });
                    }
                    reject(err);
                });
        });
    },
    getAlienAPI(url) {
        return new Promise((resolve, reject) => {
            Vue.axios.get(url).then((response) => resolve(response))
                .catch((err) => reject(err))
        });
    },
    deviceDetector() {
        let userAgent = navigator.userAgent.toLowerCase();
        const check = function () {
            return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop"
        };
        return {
            device: check(),
            isMobile: "desktop" != check() ? !0 : !1
        }
    }
}



// WEBPACK FOOTER //
// ./src/services.js